import './component.scss'

document.addEventListener('DOMContentLoaded', () => {
  // モーダル機能
  const modal = document.getElementById('prefecture-modal');
  const modalPrefectureName = document.getElementById('modal-prefecture-name');
  const modalCitiesList = document.getElementById('modal-cities-list');
  const closeModal = document.querySelector('.company-show-prefecture-cities-modal__close');
  const backdrop = document.querySelector('.company-show-prefecture-cities-modal__backdrop');

  // 都道府県データをJavaScriptで利用できるように
  const prefectureData = window.prefectureData || {};

  // 都道府県アイテムのクリックイベント
  const prefectureItems = document.querySelectorAll('[data-prefecture-id]');
  
  prefectureItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      
      const prefectureId = item.getAttribute('data-prefecture-id');
      const prefectureName = item.getAttribute('data-prefecture-name');
      
      fetchCitiesData(prefectureId, prefectureName);
    });
  });

  // モーダルを閉じる
  function closeModalFunc () {
    modal.style.display = 'none';
    document.body.style.overflow = 'auto';
  }

  if (closeModal) {
    closeModal.addEventListener('click', closeModalFunc);
  }
  
  if (backdrop) {
    backdrop.addEventListener('click', closeModalFunc);
  }

  // ESCキーでモーダルを閉じる
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal && modal.style.display !== 'none') {
      closeModalFunc();
    }
  });

  // 市区町村データを取得してモーダルを表示
  function fetchCitiesData(prefectureId, prefectureName) {
    if (!modal || !modalPrefectureName || !modalCitiesList) {
      return;
    }
    
    modalPrefectureName.textContent = prefectureName;
    
    // 市区町村データを取得
    const cities = getCitiesForPrefecture(prefectureId);

    // 市区町村を読み順でグループ分け
    const groupedCities = groupCitiesByYomi(cities);

    // 市区町村リストを生成
    modalCitiesList.innerHTML = '';
    
    Object.keys(groupedCities).sort().forEach(function(group) {
      // グループヘッダーを作成
      const groupHeader = document.createElement('div');
      groupHeader.className = 'company-show-prefecture-cities-modal__group-header';
      groupHeader.textContent = group;
      modalCitiesList.appendChild(groupHeader);
      
      // そのグループの市区町村をグリッドに配置
      const groupGrid = document.createElement('div');
      groupGrid.className = 'company-show-prefecture-cities-modal__group-grid';
      
      const cities = groupedCities[group];
      
      // 3列で行を作成
      for (let i = 0; i < cities.length; i += 3) {
        const cityRow = document.createElement('div');
        cityRow.className = 'company-show-prefecture-cities-modal__city-row';
        
        // 1行につき最大3つの市区町村
        for (let j = 0; j < 3 && i + j < cities.length; j++) {
          const cityItem = document.createElement('div');
          cityItem.className = 'company-show-prefecture-cities-modal__city-item';
          cityItem.textContent = cities[i + j];
          cityRow.appendChild(cityItem);
        }
        
        groupGrid.appendChild(cityRow);
      }
      
      modalCitiesList.appendChild(groupGrid);
    });
    
    // モーダルを表示
    modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  // 都道府県IDから市区町村を取得
  function getCitiesForPrefecture(prefectureId) {
    const prefecture = prefectureData.find(p => p.id.toString() === prefectureId.toString());
    return prefecture ? prefecture.cities : [];
  }

  // 市区町村をカタカナ読みでグループ分け
  function groupCitiesByYomi(cities) {
    const groups = {};
    const katakanaGroups = {
      'あ行': ['ア', 'イ', 'ウ', 'エ', 'オ'],
      'か行': ['カ', 'キ', 'ク', 'ケ', 'コ', 'ガ', 'ギ', 'グ', 'ゲ', 'ゴ'],
      'さ行': ['サ', 'シ', 'ス', 'セ', 'ソ', 'ザ', 'ジ', 'ズ', 'ゼ', 'ゾ'],
      'た行': ['タ', 'チ', 'ツ', 'テ', 'ト', 'ダ', 'ヂ', 'ヅ', 'デ', 'ド'],
      'な行': ['ナ', 'ニ', 'ヌ', 'ネ', 'ノ'],
      'は行': ['ハ', 'ヒ', 'フ', 'ヘ', 'ホ', 'バ', 'ビ', 'ブ', 'ベ', 'ボ', 'パ', 'ピ', 'プ', 'ペ', 'ポ'],
      'ま行': ['マ', 'ミ', 'ム', 'メ', 'モ'],
      'や行': ['ヤ', 'ユ', 'ヨ'],
      'ら行': ['ラ', 'リ', 'ル', 'レ', 'ロ'],
      'わ行': ['ワ', 'ヰ', 'ヱ', 'ヲ', 'ン']
    };

    cities.forEach(function(city) {
      // 市区町村の読みがない場合は名前を使用
      const yomi = city.yomi || city.name || city;
      const firstChar = yomi.charAt(0);
      
      // どの行に属するかを判定
      let groupName = 'その他';
      for (const [group, chars] of Object.entries(katakanaGroups)) {
        if (chars.includes(firstChar)) {
          groupName = group;
          break;
        }
      }
      
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      
      // 市区町村名（読みではなく漢字名）を追加
      const cityName = city.name || city;
      groups[groupName].push(cityName);
    });

    // 各グループ内で読み順でソート
    Object.keys(groups).forEach(function(group) {
      groups[group].sort(function(a, b) {
        // 対応する読みでソート
        const aCity = cities.find(c => (c.name || c) === a);
        const bCity = cities.find(c => (c.name || c) === b);
        const aYomi = aCity ? (aCity.yomi || aCity.name || aCity) : a;
        const bYomi = bCity ? (bCity.yomi || bCity.name || bCity) : b;
        return aYomi.localeCompare(bYomi);
      });
    });

    return groups;
  }
});
